export const getToken = (type = 'access_token_prev'): string | undefined => {
  const token = localStorage.getItem(type)
  return token || undefined
}

export const handleError = (error: any): void => {
  if (error.response) throw error.response
  throw {
    status: error.status || 500,
    data: {
      error: error.code || 'server_error',
      error_description: error.message || 'Ocorreu um erro interno',
    },
  }
}
